<div class="ui-g-12 ui-sm-12">
  <div class="background ui-g-12">
    <div class="ui-g-12">
      <h2 class="title">Cupones Disponibles</h2>
    </div>
</div>
    <div class="ui-g-12">

      <ul *ngFor="let coupon of coupons;">
       <li>
          <div class="ui-g-12 ui-md-6 ui-lg-6">
            <div class="cardGray3 ui-g-12" style="min-height: 250px !important;">
              <div class="ui-g-12">
                <div class="ui-g-12" style="align-items: center; display:flex;">
                  <img style="width: 100px; margin: 0 auto;" src="assets/images/new-icons/cupones.png">
                </div>
                <div class="ui-g-12">
                  <div class="ui-g-12">
                    <label style="font-family: poppins; font-weight: 400; text-align: center; color: #073c8f; font-size: 18px;">{{coupon.title}}</label>
                  </div>
                  <div class="ui-g-12">
                    <label style="color: #073c8f;">Válido hasta: {{coupon.dateValid}}</label>
                  </div>
                  <div class="ui-g-12" *ngIf="coupon.status.indexOf('disponible') > -1">
                    <label style="color: #2f9c0a">{{coupon.status}}</label>
                  </div>
                  <div class="ui-g-12" *ngIf="coupon.status.indexOf('utilizado') > -1">
                    <label style="color: #c92c2c">{{coupon.status}}</label>
                  </div>
                  <div class="ui-g-12" *ngIf="coupon.status.indexOf('utilizado') > -1">
                    <label>Proveedor donde se utilizo: {{coupon.providerUse}}</label>
                  </div>
                  <div class="ui-g-12">
                    <label style="color: #073c8f;">Código: {{coupon.token}}</label>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-12 ui-sm-12" style="align-items: flex-end; align-content: flex-end;">
                  <div class="ui-g-8 ui-md-4 ui-lg-4">
                    <button pButton type="button" style="width: 100%; margin: 1%;" class="ui-button-primary ui-widget ui-state-default" (click)="newWindow(coupon.url)" label="Ver Pdf"></button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
